import { Box, useMediaQuery, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import type Employee from '@src/Objects/Employee';
import React from 'react';
import OverviewSections from './components/OverviewSections';
import ProfileHeader from './components/ProfileHeader';

interface ProfileCardProps {
    employee: Employee;
    itsMe: boolean;
    orgUnit?: { id: number; title: string };
    isTeamLead?: boolean;
}

function ProfileCard({ employee, itsMe, orgUnit, isTeamLead = false }: ProfileCardProps) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box
            sx={{
                background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.08)} 0%, ${alpha(theme.palette.secondary.main, 0.1)} 100%)`,
                overflow: 'hidden',
                width: '100%',
                borderRadius: 3,
                boxShadow: 2,
            }}
        >
            <Box sx={{ px: { xs: 2, lg: 3 }, pt: 1 }}>
                <ProfileHeader
                    employee={employee}
                    itsMe={itsMe}
                    orgUnit={orgUnit}
                    isTeamLead={isTeamLead}
                    isMobile={isMobile}
                    showOverviewTiles={false}
                />

                <Box>
                    <OverviewSections employee={employee} />
                </Box>
            </Box>
        </Box>
    );
}

export default ProfileCard;
